import {docCallAccptNumber, docCallNumber, getTodayReservationList, getTodayReservationStat, signReOrder} from "@/api";
import {message, getTodayDate, messageHtml} from "../../utils/common";
import {ElMessageBox} from "element-plus";
import baseConfig from "@/api/config";
import {startReservationAutoRefresh, stopReservationAutoRefresh} from "@/assets/utils/reservationRefresh";

export default {
    data() {
        return {
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            queryParams: {
                schDate: getTodayDate(),
                doctorId: null,
                reStatus: '',
            },
            tableLoading: false,
            tableData: [],
            listRequestInFlight: false,
            doctorInfo: null,
            callPageStats: [
                {key: 'all', label: '全部', status: '', count: 0},
                {key: 'sign', label: '待签到', status: '8', count: 0},
                {key: 'wait', label: '待就诊', status: '5', count: 0},
                {key: 'done', label: '已就诊', status: '2', count: 0},
                {key: 'jump', label: '已过号', status: '7', count: 0}
            ],
            dateTime: '',
            tableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,
            reservationRefreshTimer: null,
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },
        }
    },
    mounted() {
        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
        setTimeout(() => {
            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 80;
        },1000)
    },
    created() {
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.patientInfo.docId = this.doctorInfo.doctorId;
            this.queryParams.doctorId = this.doctorInfo.doctorId;
        }
        this.getCallNumberListInfo();
        startReservationAutoRefresh(this, () => this.getCallNumberListInfo(true));
    },
    beforeUnmount() {
        stopReservationAutoRefresh(this);
    },
    methods: {
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams.schDate = getTodayDate();
            this.queryParams.reStatus = '';
            this.currentPage = 1;
            this.getCallNumberListInfo();
        },

        // 点击状态卡片筛选叫号列表
        chooseStatusCard(status) {
            this.queryParams.reStatus = status;
            this.currentPage = 1;
            this.getCallNumberListInfo();
        },

        // 切换分页
        handleCurrentChange: function(val) {
            this.currentPage = val;
            this.getCallNumberListInfo();
        },

        // 切换分页
        handleSizeChange: function(val) {
            this.pageNums = val;
            this.getCallNumberListInfo();
        },


        // 查询叫号列表（silent=true 时为定时自动刷新，不清空表格、不显示 loading，避免面板闪烁）
        getCallNumberListInfo: function (silent = false) {
            // 上一轮自动刷新请求尚未返回时跳过本轮，避免请求堆积
            if (silent && this.listRequestInFlight) return;
            if (!silent) {
                this.tableData = [];
                this.tableLoading = true;
            }
            this.listRequestInFlight = true;
            const data = {
                pageNum: this.currentPage,
                pageSize: this.pageNums,
                schDate: this.queryParams.schDate,
                doctorId: this.queryParams.doctorId,
                reStatus: this.queryParams.reStatus,
                //按排队号（签到/现场挂号顺序）排序展示
                queueOrder: '1',
            };
            this.getCallPageStats();
            getTodayReservationList(data).then(res => {
                console.log("getCallNumberListInfo >>>> " + JSON.stringify(res));
                const rdata = res.data;
                console.log(rdata);
                this.tableLoading = false;
                this.listRequestInFlight = false;
                if (rdata.code === 200) {
                    this.tableData = rdata.rows;
                    this.totalCount = rdata.total;

                    this.tableData.forEach((item) => {
                        let birYear = new Date(item.cardPatientBirth).getFullYear();
                        let nowYear = new Date().getFullYear();
                        item.age = parseInt(nowYear - birYear);
                        item.reTimeTypeText = item.reTimeType === 'am'?'上午': item.reTimeType === 'pm'?'下午':'晚上';
                        item.reStatusText = item.reStatus === '1' ? '待支付' : item.reStatus === '2' ?
                            '已完成' : item.reStatus === '3' ? '已失效' : item.reStatus === '4' ? '已取消' : item.reStatus === '5' ?
                                '待就诊' : item.reStatus === '6' ? '就诊中' : item.reStatus === '7' ? '已过号' : item.reStatus === '8' ? '待签到' : '未知';
                        if (item.cardPatientSex === '0') {
                            item.sexText = '男';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                        } else if (item.cardPatientSex === '1'){
                            item.sexText = '女';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                        } else {
                            item.sexText = '未知';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                        }
                    })
                }
            }).catch(error => {
                this.listRequestInFlight = false;
                // 静默刷新失败只记录，不弹错误提示，避免定时刷新反复弹窗
                if (silent) {
                    console.error("auto refresh failed:", error);
                } else {
                    message(error, "error");
                }
            });
        },

        // 查询顶部统计卡片（单次聚合请求，按状态返回计数）
        getCallPageStats() {
            getTodayReservationStat({
                schDate: this.queryParams.schDate,
                doctorId: this.queryParams.doctorId,
            }).then(res => {
                const rdata = res.data || {};
                if (rdata.code === 200 && rdata.data) {
                    const d = rdata.data;
                    const statusFieldMap = {'': 'total', '8': 'waitSign', '5': 'waitVisit', '2': 'done', '7': 'jumpCall'};
                    this.callPageStats.forEach(stat => {
                        const field = statusFieldMap[stat.status];
                        stat.count = field ? (d[field] || 0) : 0;
                    });
                }
            }).catch(() => {});
        },

        // 签到
        handleSign(row) {
            const reId = row.reId;
            ElMessageBox.confirm('确定要签到？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
            }).then(() => {
                signReOrder(reId).then(res => {
                    if (res.code === 200) {
                        //后端签到时分配当天排队号，随签到结果回传
                        message(res.data ? "签到成功，排队" + res.data + "号" : "签到成功", "success");
                        this.getCallNumberListInfo();
                    } else {
                        message(res.msg || "签到失败", "warning");
                        this.getCallNumberListInfo();
                    }
                }).catch(error => {
                    message(error, "error");
                });
            }).catch(() => {});
        },

        // 叫号
        calling(row) {
            // console.log(row);
            let cardPatientName = row.cardPatientName;
            docCallNumber(cardPatientName).then(res => {
                console.log(res);
                if (res.code === 200) {
                    messageHtml("正在呼叫 <span class='font_orange font_18 mrlr10'>"+cardPatientName+"</span> 前往诊室就诊", "success");
                }
            });
        },


        // 接诊
        callToOrder(row) {
            // console.log(row);
            this.patientInfo.name = row.cardPatientName;
            this.patientInfo.sex = row.cardPatientSex;
            this.patientInfo.phoneNumber = row.cardPatientPhone;
            this.patientInfo.identity = row.cardIdentity;
            let reId = row.reId;
            console.log(reId)
            docCallAccptNumber(reId).then(res => {
                console.log(res);
                if (res.code === 200) {
                    this.isOpenCallNumber = false;
                    // 叫号成功后，跳到接诊页面
                    window.sessionStorage.removeItem("reservationPatient");
                    window.sessionStorage.setItem("reservationPatient", JSON.stringify(this.patientInfo));

                    this.$router.push({path: '/admin/clinictreat'});
                    this.$store.state.adminleftnavnum = 'clinictreat'; //设置左侧导航2-2 active
                }
            });
        },

    }
}
